import { useNavigate } from "react-router-dom";
import { DeliveryNotesPage as DeliveryNotesPageView } from "@/components/DeliveryNotesPage";

export function DeliveryNotesPage() {
  const navigate = useNavigate();
  return <DeliveryNotesPageView onSelect={(id) => navigate(`/delivery-notes/${id}`)} />;
}
